import {FirebaseError} from 'firebase/app';
import {ChangePasswordError} from '@aviary/services/auth.service';

export function isIncorrectCurrentPasswordFailure(error: unknown): boolean {
  return error instanceof ChangePasswordError && error.context === 'reauthentication' && isIncorrectPasswordError(error.cause);
}

function isIncorrectPasswordError(error: unknown): boolean {
  return error instanceof FirebaseError && ['auth/wrong-password', 'auth/invalid-credential'].includes(error.code);
}
